import { ReactNode, useEffect, useRef, useState } from 'react';

import { LAZY_LOAD_OFFSET } from '../globals';

interface LazyLoadProps {
  children: ReactNode;
  offset?: number;
  once?: boolean;
  className?: string;
}

const LazyLoad = ({
  children,
  offset = LAZY_LOAD_OFFSET,
  once = true,
  className,
}: LazyLoadProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current || (isVisible && once)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          if (once) observer.disconnect();
        }
      },
      { rootMargin: `${offset}px` },
    );

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [isVisible, offset, once]);

  return (
    // eslint-disable-next-line @opendoor/no-html-elements
    <div ref={containerRef} className={className}>
      {isVisible ? children : null}
    </div>
  );
};

export default LazyLoad;
